import { datadogLogs } from "@datadog/browser-logs";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const MAX_HISTORY_LENGTH = 10;

export const DatadogRouteTracker: React.FC = () => {
  const location = useLocation();
  const historyRef = useRef<Array<{ path: string; timestamp: string }>>([]);

  useEffect(() => {
    const entry = {
      path: location.pathname + location.search,
      timestamp: new Date().toISOString(),
    };

    historyRef.current = [...historyRef.current.slice(-(MAX_HISTORY_LENGTH - 1)), entry];

    datadogLogs.setGlobalContextProperty("browsingHistory", historyRef.current);
  }, [location]);

  return null;
};
